import React, { Fragment } from "react";
import SliderCard01 from "./SliderCard01/SliderCard01";

const ContainerSliders = ({ options }) => {
  //Des
  const { objinfo = {} } = options;
  const { version } = objinfo || {};

  const cards = {
    slider_card_01: <SliderCard01 options={options} />,
  };

  const actual_card = cards[version] || false;

  return <Fragment>{actual_card}</Fragment>;
};

export default ContainerSliders;
